/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientAlreadyExists/view.blocks to change it.
import Contactofficegraphic01 from 'DesignSystem/Svgs/Contactofficegraphic01/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PatientAlreadyExists({
  children,
  viewPath = "/App/PatientAlreadyExists",
  text
  
}) {
  return (<React.Fragment
>
<div
  data-testid="PatientAlreadyExists.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Contactofficegraphic01
  viewPath={`${viewPath}/Contactofficegraphic01`}
 width={360}
 height={200}
/>
<div
  data-testid="PatientAlreadyExists.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Question
  viewPath={`${viewPath}/Question`}
 textAlign="center"
 text={text}
/>
</div>
</div>
{children}
</React.Fragment>)
}